import { Highlight, Snippet } from 'react-instantsearch-hooks-web';
import { classnames } from 'tailwindcss-classnames';
import ImageWrapper from 'components/helpers/ImageWrapper/ImageWrapper';
import { formatDateShortMonth } from 'lib/util/date-formatters';
import { HitHeadline } from '../_HitHeading';
import { HitProps } from '../_types';

export const EmployeeBlogArticleHit = ({ hit }: HitProps) => {
  const { topics, publishedDate } = hit;
  const formattedDate = publishedDate
    ? formatDateShortMonth(new Date(publishedDate).toISOString())
    : '';
  const tagClasses = classnames('mr-3');

  return (
    <div>
      <div className={classnames('md:flex', 'grid-cols-3', 'md:gap-5', 'lg:gap-7')}>
        <div className={classnames('flex-none', 'w-64', 'hidden', 'md:block')}>
          <ImageWrapper
            field={{ value: { src: hit.featuredImage, width: '256px', height: '151px' } }}
          />
        </div>
        <div className={classnames('flex-1', 'overflow-hidden')}>
          <div className={classnames('flex', 'items-start', 'mb-2')}>
            {formattedDate && <span className={tagClasses}>{formattedDate}</span>}
            {topics?.[0] && (
              <>
                <span className={tagClasses}>|</span>
                <span className={tagClasses}>{topics[0]}</span>
              </>
            )}
          </div>
          <HitHeadline hit={hit}>
            <Highlight hit={hit} attribute="pageTitle" />
          </HitHeadline>
          <div className={classnames('mb-2')}>{hit.author}</div>
          <Snippet
            hit={hit}
            attribute="description"
            className={classnames('line-clamp-4', 'md:line-clamp-2')}
          />
        </div>
      </div>
    </div>
  );
};
